export const AddToPhotos = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.33333 4.66667H0V23.3333H18.6667V21H2.33333V4.66667ZM23.3333 0H4.66667V18.6667H23.3333V0ZM19.8333 10.5H15.1667V15.1667H12.8333V10.5H8.16667V8.16667H12.8333V3.5H15.1667V8.16667H19.8333V10.5Z"
        fill="#C4C4CD"
      />
    </svg>
  );
};
